import { inject } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import { ActionResult } from '~/models/shared/result'

import {
  AccessToggleIdentifier,
  AccessToggleName,
  AccessTogglesResult
} from '~/models/user/access-toggles'
import RequestBuilder from '~/builders/http/RequestBuilder'

@containerScoped()
export default class AccessTogglesService {
  constructor(@inject(RequestBuilder) private requestBuilder: RequestBuilder) {}

  getAccessToggles(
    identifier: AccessToggleIdentifier
  ): Promise<AccessTogglesResult> {
    return this.requestBuilder
      .request('get', `/api/admin/user/${identifier}/access-toggles/`)
      .send()
  }

  enableAccessToggle(
    identifier: AccessToggleIdentifier,
    accessToggleName: AccessToggleName
  ): Promise<ActionResult> {
    return this.requestBuilder
      .request('post', `/api/admin/user/${identifier}/access-toggles/`)
      .data({ access_toggle: accessToggleName })
      .action()
      .send()
  }

  disableAccessToggle(
    identifier: AccessToggleIdentifier,
    accessToggleName: AccessToggleName,
    reason: string = ''
  ): Promise<ActionResult> {
    return this.requestBuilder
      .request('delete', `/api/admin/user/${identifier}/access-toggles/`)
      .data({ access_toggle: accessToggleName, disallow_reason: reason })
      .action()
      .send()
  }
}
